<script setup>
import { defineProps, defineEmits, computed} from "vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "controlesDesativados",
]);

const emits = defineEmits([
    "update:alteraDado",
]);

//==================================================================//
//========================= Altera Dado ============================//
//==================================================================//

const alteraDado = (update) => {

    emits('update:alteraDado',update);

};

//==================================================================//
//============== Desativa Condições de Pagamento ===================//
//==================================================================//

const desativaCondicoesDePagamento = computed(()=>{

    if(props?.controlesDesativados){
        return true;
    }

    if(props?.dado?.status == "Em Execução"){
        return true;
    }

    return false;

});

//==================================================================//
//============== Ao Preencher Condicao De Pagamento ================//
//==================================================================//

const aoPreencherCondicaoDePagamento = (condicaoDePagamento) => {

    alteraDado({
        condicaoDePagamento: condicaoDePagamento
    });
    
};

</script>

<template>

    <v-card class="c-cartao">

        <v-card-title class="c-cartao__titulo">

            <h3 class="c-titulo">

                Condições de Pagamento

            </h3>

        </v-card-title>

        <div class="c-cartao__conteudo">

            <div class="c-campo">

                <v-textarea
                    :value="props?.dado?.condicaoDePagamento"
                    :disabled="desativaCondicoesDePagamento"
                    label="Condições de Pagamento"
                    variant="outlined"
                    no-resize
                    outlined
                    auto-grow
                    @input="aoPreencherCondicaoDePagamento"
                ></v-textarea>

            </div>

        </div>

    </v-card>

</template>

<style scoped>

.c-cartao__titulo{
    display: grid; 
    grid-template-columns: 1fr; 
    grid-template-rows: 1fr; 
    gap: 10px; 
    grid-template-areas: 
        "titulo";
}

.c-titulo {
    grid-area: titulo;
}

</style>